// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchResults_wrapper__FoDQ9","fadeIn":"SearchResults_fadeIn__i_lra"};